(function () {
    'use strict';
    var MedicationAllergiesBaseCtrl = function (autoInit) {
        return function (_, $scope, $stateParams, MyChartService, PatientPortalStorageRepository) {

            var activePatient = PatientPortalStorageRepository.getActivePatient();
            var loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };

            $scope.model = {
                MedicationAllergies: null

            };

            function auditMedicationAllergies(reportRequestDto) {
                MyChartService.auditMedicationAllergiesLogging(reportRequestDto);
            }

            function initialize() {
                $scope.loading = true;
                $scope.removeHttpError();
                MyChartService
                    .getMedicationAllergies(activePatient.id)
                    .then(function (data) {
                        $scope.model.MedicationAllergies = data.plain();
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
                auditMedicationAllergies(reportRequestDto);
            }

            $scope.tileState = {
                isCollapsed: undefined
            };

            function toggleState() {
                if ($scope.tileState.isCollapsed === undefined) {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            }

            if (autoInit) {
                initialize();
            }

            $scope.auditMedicationAllergies = auditMedicationAllergies;
            $scope.toggleState = toggleState;
        };
    };

    var MedicationAllergiesCtrl = new MedicationAllergiesBaseCtrl(true);
    var MedicationAllergiesMobileCtrl = new MedicationAllergiesBaseCtrl(false);

    angular.module('mychart').controller('MedicationAllergiesCtrl',
        ['_', '$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository',
            MedicationAllergiesCtrl]);
    angular.module('mychart').controller('MedicationAllergiesMobileCtrl',
        ['_', '$scope', '$stateParams', 'MyChartService', 'PatientPortalStorageRepository',
            MedicationAllergiesMobileCtrl]);
})();